// extracted by mini-css-extract-plugin
export var $animation_name = "CompetitionPrizes-module--$animation_name--86400";
export var prize = "CompetitionPrizes-module--prize--5b66d";
export var prizeIcon = "CompetitionPrizes-module--prizeIcon--855a7";
export var prizes = "CompetitionPrizes-module--prizes--9fdb4";
export var viewportAnimation = "CompetitionPrizes-module--viewportAnimation--56e55";
export var wrapper___isInViewport = "CompetitionPrizes-module--wrapper___isInViewport--0076c";